import CryptoJS from 'crypto-js';

// Récupérer depuis .env
const key = CryptoJS.enc.Utf8.parse(import.meta.env.VITE_AES_KEY as string);
const iv = CryptoJS.enc.Utf8.parse(import.meta.env.VITE_AES_IV as string);

export const encrypt = (text: string): string => {
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export const decrypt = (cipherText: string): string => {
  const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};
